import React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { connect } from 'react-redux';
import setSearchCityAction from '../../redux/actions/searchReferenceActions/actionSearchCity';
import { withTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';

const StyledTextField = styled(TextField)({
  '& .MuiOutlinedInput-notchedOutline': {
    '&:hover': {
      borderColor: "rgb(0,191,255)",
    },
    '&.Mui-focused': {
      borderColor: "rgb(47, 79, 79)",
    },
  },
  '& .Mui-focused': {
    color: 'white',
  },
  width: 300,
  marginTop: 10,
  fontSize: 30,
  backgroundColor: 'rgba(19, 174, 236, 0.54)',
  fontWeight: 'bold'
});


class SearchCityForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = { city: '', cities: { data: [{ 'city': '' }] } };
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeForm = this.handleChangeForm.bind(this);
        // set redux store to empty if get link SearchReference
        this.props.setSearchCityFunction('');

    }

    // fetch by adding charachters in city-inputform
    async handleChange(event) {

        this.setState({ city: event.target.value });
        if (event.target.value.length >= 1) {
            const response = await fetch(`${process.env.REACT_APP_EXPRESS_SERVER}/searchRef/city?city=${this.state.city}&language=${localStorage.getItem('language')}`);
            const json = await response.json();
            this.setState({ cities: json });
        }
        // console.log(this.state.city);
    };

    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.city !== nextProps.city) {
            this.setState({city: '', cities: { data: [{ 'city': '' }] }}, () => {
             this.props.setSearchCityFunction(this.state.city);
            })
             return false;
           } else {
             return true;
           }
         }

    handleChangeForm(event, value) {
        if (value !== null) {
            this.setState({ city: value }, () => {
                this.props.setSearchCityFunction(this.state.city);
            });

        } else {
            this.setState({ city: '' }, () => {
                this.props.setSearchCityFunction(this.state.city);
            })
        }
        // console.log(value);
    };


    render() {
        const { classes } = this.props;
        const { t } = this.props;

        return (
            <div>
                <Autocomplete
                classes={classes}
                    id="combo-box-city"
                    onChange={this.handleChangeForm}
                    options={this.state.cities.data}
                    isOptionEqualToValue={(option, value) => option.city === value.city}
                    getOptionLabel={(option) => option.city}
                    noOptionsText={'Wrong input data'}
                    // filterSelectedOptions={true}
                    renderInput={(params) => <StyledTextField {...params} style={{ width: 300, margin: 10, fontSize: 30, backgroundColor: 'rgba(19, 174, 236, 0.54)' }} onChange={this.handleChange} label={t("create_ref.city")} variant="outlined" />}
                />
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return{
        setSearchCityFunction: searchCity => {
            dispatch(setSearchCityAction(searchCity)) 
        }
    }
}

export default connect(null, mapDispatchToProps)(withTranslation()(SearchCityForm));